import { render } from "./CartSubOrddet.vue?vue&type=template&id=45c1190c&scoped=true"
import script from "./CartSubOrddet.vue?vue&type=script&lang=js"
export * from "./CartSubOrddet.vue?vue&type=script&lang=js"

import "./CartSubOrddet.vue?vue&type=style&index=0&id=45c1190c&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c1190c"]])

export default __exports__